export default __webpack_public_path__ + "static/media/Greaves of the Fallen Empire (nm).70425fdf.jpg";